import * as vp from 'vopay';
import { Box, SubTitle, Card } from 'vopay';
import { TransactionStatus, Table } from 'UI';

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import useFetchAccountBillingSettings from '@/hooks/useApi/useFetchAccountBillingSettings';

const Billing = () => {
  const { accountId } = useParams<{ accountId: string }>();
  const [accountBillingSettings, getAccountBillingSettings] = useFetchAccountBillingSettings({});

  useEffect(() => {
    getAccountBillingSettings(accountId);
  }, []);

  const tableProps: vp.TableProps<vp.BillingSettingBasics> = {
    id: 'account-billing-settings-list',
    version: '2',
    zebra: true,
    columns: [
      {
        id: 'packageName',
        header: 'Package Name',
        align: 'left',
        template: ({ data }) => (
          <Table.Link
            to={{
              pathname: `billing/settings/${data.ID}`,
              search: new URLSearchParams({
                packageName: data.PackageName,
              }).toString(),
            }}
          >
            {data.PackageName}
          </Table.Link>
        ),
      },
      {
        id: 'status',
        header: 'Status',
        align: 'left',
        template: ({ data }) => (
          <TransactionStatus
            label={data.IsActive ? vp.AccountStatus.Active : vp.AccountStatus.InActive}
            status={data.IsActive ? 'positive' : 'neutral'}
          />
        ),
      },
      {
        id: 'currency',
        header: 'Currency',
        align: 'left',
        field: 'Currency',
      },
      {
        id: 'start',
        header: 'Start Date',
        align: 'left',
        field: 'StartDate',
      },
      {
        id: 'end',
        header: 'End Date',
        align: 'left',
        template: ({ data }) => (data.EndDate === '9999-12-31' ? 'current' : data.EndDate),
      },
    ],
    rows: accountBillingSettings.map((settings) => ({
      id: settings.ID,
      data: settings,
    })),
  };

  return (
    <Box flx="col" gapSize="36px">
      <Box mt="lg">
        <SubTitle subTitle="Billing Settings" />
      </Box>
      <Card
        style={{
          padding: '16px',
        }}
      >
        <Table {...tableProps} />
      </Card>
    </Box>
  );
};

export default Billing;
